(function () {
  if (window.juzyCartSuggestionReady) return;
  window.juzyCartSuggestionReady = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-juzy-suggest-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var box = button.closest('[data-juzy-cart-suggestion]');
    var errorEl = box && box.querySelector('.juzy-cs__error');
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!button.closest('#main-cart-items');
    var useDrawer = !onCartPage && drawer && typeof drawer.renderContents === 'function';

    var payload = { id: Number(button.dataset.variantId), quantity: 1 };
    if (useDrawer) {
      payload.sections = 'cart-drawer,cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    button.disabled = true;
    button.textContent = button.dataset.addingText || '…';
    if (errorEl) errorEl.hidden = true;

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status || state.errors) {
          throw new Error(state.description || state.message || 'error');
        }
        if (useDrawer) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function (error) {
        console.error(error);
        if (errorEl) {
          errorEl.textContent = (window.cartStrings && window.cartStrings.error) || '';
          errorEl.hidden = false;
        }
        button.disabled = false;
      });
  });
})();
